import React from "react";

function RabbitDetails({ product }) {
    if (!product) return <p>Məlumat tapılmadı.</p>;

    return (
        <div className="rabbit-details">
            <h3>Dovşan Məlumatları</h3>
            <ul>
                <li><strong>Adı:</strong> {product.name || "Bilinmir"}</li>
                <li><strong>Növü:</strong> {product.rabbitType || "Bilinmir"}</li>
                <li><strong>Yaş:</strong> {product.age ? `${product.age} ay` : "Bilinmir"}</li>
                <li><strong>Cins:</strong> {product.gender || "Bilinmir"}</li>
                <li><strong>Rəng:</strong> {product.color || "Bilinmir"}</li>
                <li><strong>Çəkisi:</strong> {product.weight ? `${product.weight} kq` : "Bilinmir"}</li>
                <li><strong>Sağlamlıq vəziyyəti:</strong> {product.healthStatus || "Bilinmir"}</li>
                <li><strong>Qəfəs daxildir:</strong> {product.includesCage ? "Bəli" : "Xeyr"}</li>
                <li><strong>Qiymət:</strong> {product.price ? `${product.price} AZN` : "Qiymət mövcud deyil"}</li>
                <li><strong>Şəhər:</strong> {product.city || "Bilinmir"}</li>
                    <li style={{flexDirection:"column"}}>
                    <strong>Əlavə təsvir</strong>
                    <p >
                        {product.description || "Açıqlama mövcud deyil."}
                    </p>
                </li>
            </ul>
        </div>
    );
}

export default RabbitDetails;
